<template>
  <div class="row mx-0 px-3 py-4 border-top">
    <label class="form-label size-12" for="">希望業種</label>
    <div class="input-group d-flex w-100 pe-0 gap-3 flex-column">
      <div
        v-for="(desired_industry, index) in optionalInformationStore.profile_desired_industires"
        :key="index"
        class="d-flex w-100 gap-3"
      >
        <div class="pe-0 col-md-4 col-10">
          <Field
            v-slot="{ field }"
            v-model="desired_industry.industry_id"
            :name="`desired-industry${index}`"
          >
            <select
              class="form-select select-input-primary size-14 p-0d8 pe-4"
              v-bind="field"
              @change="onChangeIndustryId($event, desired_industry, index)"
            >
              <option :value="0" disabled selected>選択してください</option>
              <optgroup
                v-for="industry in filteredIndustries(index)"
                :key="industry.id"
                :label="industry.name"
              >
                <option v-for="item in industry.children" :key="item.id" :value="item.id">
                  {{ item.name }}
                </option>
              </optgroup>
            </select>
            <ErrorMessage :name="`desired-industry${index}`" class="invalid-feedback" />
          </Field>
        </div>
        <div class="d-flex justify-content-center align-items-center flex-column ms-2">
          <img
            alt="Remove icon"
            class="h-29x w-29x cursor-pointer"
            src="@/assets/images/icons/remove-icon.svg"
            @click="onRemoveIndustry(index)"
          />
        </div>
      </div>
      <div class="d-flex justify-content-center align-items-center flex-column w-100 m-0">
        <button
          v-if="optionalInformationStore.profile_desired_industires.length < maxItem"
          type="button"
          class="btn btn-outline-secondary p-0d8 d-flex justify-content-center align-items-center size-12 w-12 rounded-5 h-36x"
          @click="addItemForDesiredIndustry"
        >
          <div class="icon w-1"></div>
          <span class="ms-2">希望業種を追加する</span>
        </button>
        <p class="d-flex justify-content-center text-secondary pe-2 pt-1 text-center">※ 3つまで</p>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { onMounted, ref } from 'vue';
import { IndustryType } from '@/types/models/industryType';
import { useOptionalInformationStore } from '@/stores/resume-candidate/OptionalInformation.store';
import { getIndustries } from '@/apis/candidate';
import { Field, useFieldArray, ErrorMessage } from 'vee-validate';
import { pullAt } from 'lodash';

const industries = ref<IndustryType[]>([]);
const optionalInformationStore = useOptionalInformationStore();
const maxItem = 3;
const { update, remove } = useFieldArray('profile_desired_industires');

onMounted(() => {
  loadIndustries();
});

const loadIndustries = async (): Promise<void> => {
  const response = await getIndustries();
  if (response.status === 200) industries.value = response.data;
};

const filteredIndustries = (index: number): IndustryType[] => {
  return industries.value.map((industry) => {
    const clonedIndustry = { ...industry };
    clonedIndustry.children = clonedIndustry.children?.filter((child) => {
      return !optionalInformationStore.profile_desired_industires.some(
        (industries, i) => industries.industry_id === child.id && i !== index
      );
    });
    return clonedIndustry;
  });
};

const addItemForDesiredIndustry = (): void => {
  if (optionalInformationStore.profile_desired_industires.length >= maxItem) return;
  optionalInformationStore.profile_desired_industires?.push({
    industry_id: 0,
    index: new Date().getTime(),
  });
};

const onChangeIndustryId = ($event: any, desired_industry: any, index: number): void => {
  update(index, { ...desired_industry, occupation_id: $event.target.value });
  const objectIndex = optionalInformationStore.profile_desired_industires.findIndex(
    (object) => object.index == desired_industry.index
  );
  optionalInformationStore.profile_desired_industires[objectIndex].industry_id =
    +$event.target.value;
};

const onRemoveIndustry = (index: number): void => {
  remove(index);
  pullAt(optionalInformationStore.profile_desired_industires, index);
};
</script>
